import type ModuleButtonsType from 'app/main/modules/components/ModuleButtonsType';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				action: ({ dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'mails',
							maxDialogWidth: 'sm',
							updateRefresh
						})
					)
			}
		]
	}
};

export default buttons;
